<template>
  <div class="wrapper shdw col-sm-2">
    <nav id="sidebar">
      <div class="sidebar-header">
        <div class="text-center py-3">
          <a href="#">
            <img
              src="../assets/Ambee1.png"
              class="img-responsive text-center"
              style="width:200px;"
            />
          </a>
        </div>
      </div>
    </nav>
    <div class="logout" style="borderTop:2px solid #DEDEDE">
      <button class="btn logout-btn p-1" @click="logout">
        <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
        Logout
      </button>
    </div>
  </div>
</template>

<script>
import { AUTH_LOGOUT } from "../store/actions/auth";
export default {
  methods: {
    logout() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    },
  },
};
</script>

<style>
.wrapper {
  height: 100vh;
  position: fixed;
}
.logout {
  text-align: center !important;
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
}
.logout:hover {
  background-color: #cc0202;
}
.logout-btn {
  font-family: Ubuntu;
  font-weight: 500;
  color: rgba(59, 59, 59, 0.8);
  background-color: transparent;
}
.logout-btn:hover{
    color:white
}

</style>